<section class="cms-content" style="padding: 80px 120px;">
    <div class="no-results" *ngIf="errors.length">
        Sorry - this questionnaire has already been completed.
    </div>

    <ng-container *ngIf="questionnaire && questionnaire.group.id === 1">
        <h4>We'd like to ask you a few questions</h4>
        <div class="text-center" style="padding: 10px 60px;">
            <p class="mt-50">
                We're always trying to identify ways to better our service and would appreciate you taking a few moments out of your day to
                answer a few questions about your recent order.
            </p>
        </div>
    </ng-container>
    <ng-container *ngIf="questionnaire && questionnaire.group.id === 2">
        <h4>We'd like to ask you a few questions :)</h4>
        <div class="text-center" style="padding: 10px 60px;">
            <p class="mt-50">
                We're always trying to identify ways to better our service and would appreciate you taking a few moments out of your day to
                answer a few questions about a recent job that was completed by one of our trusted providers.
            </p>
        </div>

    </ng-container>
</section>

<div class="container" *ngIf="questionnaire">
    <div class="row">
        <div class="col-xl-10 offset-xl-1">

            <h1 class="text-center">Please rate the products you received</h1>
            <div class="mb-50">
                <ng-container *ngFor="let product of questionnaire.products">
                    <div class="well bordered p-4 mb-4">
                        <div class="row">
                            <div class="col-9">
                                <h2 *ngIf="product.name">How would you rate the quality of {{product.name}}?</h2>
                                <h2 *ngIf="!product.name">How would you rate the quality of {{product.rangeName}} {{product.finishName}} {{product.typeName}}?</h2>
                            </div>
                            <div class="col-3 text-end">
                                <div
                                    class="rating"
                                    style="font-size: 30px; display: inline-block"
                                    (mouseleave)="clearHoverRating(product)">
                                        <span *ngFor="let r of ratings" (mouseover)="hoverRating(product, r)" (click)="setRating(product, r)">
                                            <i class="fas fa-star" [ngClass]="{'selected' : r.id <= product.rating || r.id <= product.ratingTmp}"></i>
                                        </span>
                                </div>
                            </div>
                        </div>
                        <div>
                            <span
                                style="display: inline-block"
                                (click)="toggleComment(product)">
                                    <span *ngIf="!product.addComment">Add a comment</span>
                                    <span *ngIf="product.addComment">Remove comment</span>
                                </span>
                        </div>
                        <div class="mt-2" *ngIf="product.addComment">
                <textarea
                    [(ngModel)]="product.comment"
                    class="form-control bordered"
                    placeholder="Enter your comments"></textarea>
                        </div>
                    </div>

                </ng-container>
            </div>


            <ng-container *ngFor="let section of questionnaire.sections">

                <h1 class="text-center" *ngIf="section.questions.length">{{section.name}}</h1>
                <div class="well bordered p-4 mb-4" *ngIf="section.questions.length">
                    <div *ngFor="let question of section.questions; let qidx = index">
                        <div class="row">
                            <div class="col-9">
                                <h2 style="display: inline-block">{{question.content}}</h2>
                            </div>
                            <div class="col-3 text-end">
                                <ng-container *ngIf="question.allowRating">
                                    <div
                                        class="rating"
                                        style="font-size: 30px; display: inline-block"
                                        (mouseleave)="clearHoverRating(question)">
                                        <span *ngFor="let r of ratings" (mouseover)="hoverRating(question, r)" (click)="setRating(question, r)">
                                            <i class="fas fa-star" [ngClass]="{'selected' : r.id <= question.rating || r.id <= question.ratingTmp}"></i>
                                        </span>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="!question.allowRating">
                                    <ng-select
                                        *ngIf="!question.options.length"
                                        [(ngModel)]="question.answer"
                                        [clearable]="false"
                                        [searchable]="false"
                                        [placeholder]="'Please select'"
                                        class="mb-3">
                                        <ng-option [value]="1">Yes</ng-option>
                                        <ng-option [value]="0">No</ng-option>
                                    </ng-select>

                                    <ng-select
                                        *ngIf="question.options.length"
                                        [(ngModel)]="question.answer"
                                        [clearable]="false"
                                        [searchable]="false"
                                        [placeholder]="'Please select'"
                                        class="mb-3">
                                        <ng-option *ngFor="let o of question.options" [value]="o.id">{{o.optionValue}}</ng-option>
                                    </ng-select>
                                </ng-container>
                            </div>
                        </div>

                        <div *ngIf="question.allowComments">
                            <textarea [(ngModel)]="question.comment" class="form-control bordered" placeholder="If you have any additional comments, please enter them here"></textarea>
                        </div>
                        <hr *ngIf="section.questions.length > 1 && qidx < (section.questions.length - 1)" />
                    </div>
                </div>

            </ng-container>

            <div class="well bordered p-4 mb-4" *ngFor="let metric of questionnaire.metrics">
                <div class="row">
                    <div class="col-9">
                        <h2>{{metric.strapline}}</h2>
                    </div>
                    <div class="col-3 text-end">
                        <div class="rating" (mouseleave)="clearHoverRating(metric)" style="font-size: 30px">
                            <span *ngFor="let r of ratings" (mouseover)="hoverRating(metric, r)" (click)="setRating(metric, r)">
                                <i class="fas fa-star" [ngClass]="{'selected' : r.id <= metric.rating || r.id <= metric.ratingTmp}"></i>
                            </span>
                        </div>
                    </div>
                </div>

            </div>

            <hr />

            <h2>Please enter any other feedback you might have for us</h2>
            <textarea [(ngModel)]="questionnaire.feedback" class="form-control bordered" rows="10"></textarea>

            <div class="mt-4 mb-50 text-end">
                <button type="button" (click)="complete()" class="btn btn-primary">
                    Submit
                </button>
            </div>

        </div>
    </div>


</div>
